import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const equipmentApi = createApi({
  reducerPath: "equipments",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api/`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      fetchEquipments: builder.query({
        providesTags: () => ["equipments"],
        query: (pagination) => {
          return {
            url: pagination
              ? `equipment?page=${pagination.page}&limit=${pagination.limit}&searchText=${pagination.searchText}`
              : "equipment?searchText=" + pagination.searchText,
            method: "GET",
          };
        },
      }),
      fetchGroupedEquipments: builder.query({
        providesTags: () => ["grouped-equipments"],
        query: () => {
          return {
            url: "equipment/grouped-equipments",
            method: "GET",
          };
        },
      }),
      fetchEquipmentByCategoryId: builder.query({
        providesTags: (result, err, { categoryId }) => {
          return ["category-equipments-" + categoryId];
        },
        query: (model) => {
          return {
            url: `equipment/category?categoryId=${model.categoryId ?? 1}`,
            method: "GET",
          };
        },
      }),
      postEquipment: builder.mutation({
        invalidatesTags: () => ["equipments"],
        query: (equipment) => {
          return {
            url: "equipment/",
            method: equipment.id === 0 ? "POST" : "PUT",
            body: equipment,
          };
        },
      }),
      deleteEquipment: builder.mutation({
        invalidatesTags: () => ["equipments"],
        query: (id) => {
          return {
            url: `equipment?id=${id}`,
            method: "DELETE",
          };
        },
      }),
    };
  },
});

export const {
  useFetchEquipmentsQuery,
  useFetchGroupedEquipmentsQuery,
  useFetchEquipmentByCategoryIdQuery,
  useDeleteEquipmentMutation,
  usePostEquipmentMutation,
} = equipmentApi;

export { equipmentApi };
